module.exports = __webpack_public_path__ + "img/东北大学佛山研究生院教学综合体.daa60aaa.png";